// Payment links and QR codes between platform wallets (owner, 2026-10-25): /pay?to=<wallet>&asset=<UAH|
// USD|EUR|RE>&amount=<optional>. Opened on a phone (camera) or a PC, the link prefills the transfer
// form; a guest logs in first and returns to it.
const ASSETS = ['UAH', 'USD', 'EUR', 'RE'];
const PENDING_KEY = 'pending_pay_link';

export function buildPayLink({ to, asset, amount }) {
  const q = new URLSearchParams({ to, asset });
  if (amount && Number(amount) > 0) q.set('amount', String(amount));
  return `${window.location.origin}/pay?${q.toString()}`;
}

// a valid request or null
export function parsePayQuery(query) {
  const to = String(query.to || '');
  const asset = String(query.asset || '').toUpperCase();
  const amount = query.amount === undefined || query.amount === '' ? '' : String(query.amount);
  if (!/^0x[0-9a-fA-F]{40}$/.test(to) || !ASSETS.includes(asset)) return null;
  if (amount && !(Number(amount) > 0)) return null;
  return { to, asset, amount };
}

export function savePendingPay(path) {
  try { localStorage.setItem(PENDING_KEY, path); } catch (e) { /* private mode: the user opens the link again */ }
}

export function takePendingPay() {
  try {
    const p = localStorage.getItem(PENDING_KEY);
    if (p) localStorage.removeItem(PENDING_KEY);
    return p && p.startsWith('/pay?') ? p : null;
  } catch (e) {
    return null;
  }
}
